import { fmtAmount, fmtFull } from "../../lib/big";
import { useI18n } from "../../lib/i18n";

/**
 * 只读金额：放得下就是千分位全值，太大才缩写（1.23亿 / 1.23B / 1.2e30），悬停看完整值。
 *
 * 造价没有上限（leo 2026-10-16），1e17 的千分位是 23 个字符，固定宽的表格列放不下，
 * 会把数字截成看不见的半截。缩写只是显示，算与存都按精确值走（lib/big.ts）。
 */
export function Amount({ v, className }: { v: unknown; className?: string }) {
  const { lang } = useI18n();
  const short = fmtAmount(v, lang);
  const full = fmtFull(v);
  return <span className={className} title={short === full ? undefined : full}>{short}</span>;
}

/** 非组件场景（拼进文案、占位文字）用的同一套缩写 */
export function useAmount() {
  const { lang } = useI18n();
  return (v: unknown) => fmtAmount(v, lang);
}
